var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonalizationIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.25C18 8.76375 15.9862 6.75 13.5 6.75C11.0138 6.75 9 8.76375 9 11.25C9 13.7362 11.0138 15.75 13.5 15.75C15.9862 15.75 18 13.7362 18 11.25ZM11.25 11.25C11.25 10.0125 12.2625 9 13.5 9C14.7375 9 15.75 10.0125 15.75 11.25C15.75 12.4875 14.7375 13.5 13.5 13.5C12.2625 13.5 11.25 12.4875 11.25 11.25Z",
    fill: "#2783EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8476 24.5377C13.0389 24.6727 13.2751 24.7515 13.5001 24.7515C13.7251 24.7515 13.9614 24.684 14.1526 24.5377C14.4901 24.2902 22.5339 18.4965 22.5001 11.2402C22.5001 6.27898 18.4614 2.24023 13.5001 2.24023C8.53886 2.24023 4.50011 6.27898 4.50011 11.2402C4.46636 18.4852 12.5101 24.2902 12.8476 24.5377ZM13.5001 4.50148C17.2239 4.50148 20.2501 7.52773 20.2501 11.2515C20.2726 16.2465 15.3114 20.7352 13.5001 22.209C11.6889 20.7352 6.72761 16.2577 6.75011 11.2515C6.75011 7.52773 9.77636 4.50148 13.5001 4.50148Z",
    fill: "#2783EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalizationIcon5);
export default __webpack_public_path__ + "static/media/personalization-icon5.23fa2ee3a427835a07d278c0708d679a.svg";
export { ForwardRef as ReactComponent };